export const moduleName = 'CommonModule';
